import { apiFetch } from "#lib/api";
import {
  IComment,
  IPost,
  IPostAttachment,
  IPostPreview,
  IPostRevision,
  IPostVideo,
} from "#entities/posts";

const COMMENT_SERVICES = ["boosty", "fanbox", "patreon"];

interface IResult {
  post: IPost;
  attachments: IPostAttachment[];
  previews: IPostPreview[];
  videos: IPostVideo[];
  props: {
    service: string;
    flagged: string | null;
    revisions: [number, IPost][];
  };
}

export async function fetchPost(
  service: string,
  profileID: string,
  postID: string
) {
  const path = `/${service}/user/${profileID}/post/${postID}`;
  return await apiFetch<IResult>(path, { method: "GET" });
}

export async function fetchPostComments(service: string, profileID: string, postID: string): Promise<IComment[]> {
  // Don't bother making a query for services that don't have comments.
  if (!COMMENT_SERVICES.includes(service)) {
    return new Promise((resolve) => resolve([]));
  }
  const path = `/${service}/user/${profileID}/post/${postID}/comments`;
  return await apiFetch<IComment[]>(path, { method: "GET" });
}

interface IPostData {
  service: string;
  artist_id: string;
  post_id: string;
}

export async function fetchPostData(service: string, postID: string) {
  const path = `/${service}/post/${postID}`;

  const result = await apiFetch<IPostData>(path, { method: "GET" });

  return result;
}
